import React from 'react';
import { ChevronRight } from '@/components/icons';
import { Link } from 'react-router-dom';

export default function PageHero({
  eyebrow,
  title,
  subtitle,
  image,
  breadcrumbs = [],
  badge,
  children,
  height = 'normal',
}) {
  const heightClass = height === 'tall'
    ? 'min-h-[60vh] lg:min-h-[70vh]'
    : 'min-h-[44vh] lg:min-h-[52vh]';

  return (
    <section
      className={`relative ${heightClass} flex items-end overflow-hidden bg-[#060D9C]`}
      data-testid="page-hero"
    >
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#060D9C] via-[#060D9C]/85 to-[#060D9C]/55" />
          <div className="absolute inset-0 bg-noise opacity-40" />
        </div>
      )}
      <div className="relative nft-container py-10 lg:py-16 text-white w-full">
        {breadcrumbs.length > 0 && (
          <nav aria-label="Breadcrumb" className="mb-3 flex items-center gap-1.5 text-xs text-white/70">
            {breadcrumbs.map((b, i) => (
              <React.Fragment key={i}>
                {b.to ? (
                  <Link to={b.to} className="hover:text-[#FC4E2C] label-eyebrow">{b.label}</Link>
                ) : (
                  <span className="label-eyebrow text-white">{b.label}</span>
                )}
                {i < breadcrumbs.length - 1 && <ChevronRight width={10} height={10} />}
              </React.Fragment>
            ))}
          </nav>
        )}
        {eyebrow && <div className="label-eyebrow text-[#FC4E2C] mb-3">{eyebrow}</div>}
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl xl:text-7xl uppercase max-w-4xl">
          {title}
        </h1>
        {badge && (
          <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#FC4E2C] text-white px-4 py-1.5 font-bold uppercase tracking-wider text-xs" style={{ fontFamily: 'Barlow Semi Condensed' }}>
            {badge}
          </div>
        )}
        {subtitle && (
          <p className="mt-4 text-lg lg:text-xl text-white/85 max-w-3xl leading-relaxed">
            {subtitle}
          </p>
        )}
        {children && <div className="mt-6">{children}</div>}
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-6 bg-[#F4F5F7]" style={{ clipPath: 'polygon(0 100%, 100% 0, 100% 100%)' }} aria-hidden="true" />
    </section>
  );
}
